// extracted by mini-css-extract-plugin
export var borderRadius = "_fq-4";
export var large = "_fq-3";
export var logoContainer = "_fq-0";
export var nameLogo = "_fq-2";
export var small = "_fq-1";